<div>
  <h3 class="is-size-4 mb-5">Start of chat</h3>
  <div style="display: grid">
    {#if messageArray.length > 0}
      {#each messageArray as { createdAt, text, userId, isRead }}
        <div class="mb-5 is-inline-flex" style="gap: 10px; flex-flow: column;">
          {#if (userEmail !== userId)}
            <div style="width: 100%">
              <article
                class={(isUserCharity ? 'is-info' : 'is-danger') +
                  ' message mb-10'}
                style="margin-bottom: unset">
                <p class="message-body">{text}</p>
              </article>
            </div>
            <div class="is-inline-flex" style="gap: 10px;">
              {#if !isRead}
                <div>
                  <NewMessageIcon />
                </div>
              {/if}
              <div class="is-align-self-center has-text-grey-dark">
                {#if isBusiness}
                  <p>{charityName}</p>
                {:else}
                  <p>{companyName}</p>
                {/if}
                <p>{dayjs(createdAt).format('DD/MM/YYYY')}</p>
                <p>{dayjs(createdAt).format('HH:MM')}</p>
              </div>
            </div>
          {:else}
            <div style="width: 100%">
              <article
                class={(isUserCharity ? 'is-danger' : 'is-info') +
                  ' message has-text-right'}
                style="margin-bottom: unset">
                <p class="message-body" style="border-width: 0 4px 0 0;">
                  {text}
                </p>
              </article>
            </div>
            <div
              class="has-text-right is-inline-flex is-justify-content-right"
              style="gap: 10px;">
              <div class="is-align-self-center has-text-grey-dark">
                {#if isBusiness}
                  <p>{companyName}</p>
                {:else}
                  <p>{charityName}</p>
                {/if}
                <p>{dayjs(createdAt).format('DD/MM/YYYY')}</p>
                <p>{dayjs(createdAt).format('HH:mm')}</p>
              </div>
              {#if !isRead}
                <div>
                  <NewMessageIcon />
                </div>
              {/if}
            </div>
          {/if}
        </div>
      {/each}
    {/if}
  </div>
  {#if !isAdmin}
    <div
      class="is-inline-flex"
      style="width: 100%; gap: 10px; flex-flow: column;">
      <div style="gap: 10px;">
        <textarea
          bind:value={chatText}
          placeholder="Add your message here"
          class="textarea"
          style="padding: 5px 8px;" />
      </div>
      <div class="is-align-self-center">
        <button
          class="button is-primary"
          class:is-loading={isSending}
          on:click={() => sendMessage()}
          disabled={chatText.length == 0}>Send</button>
      </div>
    </div>
  {/if}
  <hr />

  {#if errorMessage}
    <div class="block">
      <p class="notification is-danger is-light">
        {errorMessage}
      </p>
    </div>
  {/if}
</div>

<script lang="ts">
  import dayjs from 'dayjs';
  import { appState } from '../../lib/appState';
  import NewMessageIcon from './NewMessageIcon.svelte';
  export let messageIds: MessageId[];
  export let isAdmin = false;
  export let isBusiness = true;
  export let companyName = '';
  export let charityName = '';

  let firebase = window.firebase;

  const userEmail: string = $appState.auth_user.email;
  const isUserCharity: boolean = !!$appState.user?.charity;

  let id: string;

  let chatText = '';
  $: updatedMessageIds = messageIds;

  let messageArray: Message_v1[] = [];

  let isSending = false;
  let errorMessage: string;

  $: if (updatedMessageIds && updatedMessageIds.length > 0) {
    changeIsRead(messageIds);
  }

  async function getSnapshots(messageIds: string[]) {
    const db = firebase.firestore();

    const promiseRefArray = messageIds.map((id) => {
      const docRef = db.doc(`messages_v1/${id}`);
      return docRef.get();
    });
    try {
      return await Promise.all(promiseRefArray);
    } catch (error) {
      console.error('Error getting documents:', error);
    }
  }

  async function getMessages() {
    const snapshots = await getSnapshots(updatedMessageIds);

    messageArray = [];
    snapshots?.forEach((docSnapshot) => {
      if (docSnapshot && docSnapshot.exists) {
        messageArray.push(docSnapshot.data() as Message_v1);
      } else {
        console.log('Document does not exist');
      }
    });

    id = messageArray[0].requestId;
  }

  async function sendMessage() {
    if (chatText.length > 0) {
      isSending = true;
      await firebase
        .functions()
        .httpsCallable('api-messaging-createmessage')({
          text: chatText,
          requestId: id
        } as CreateMessageParams)
        .catch((err) => {
          isSending = false;
          errorMessage = err.toString();
        });
      chatText = '';
      isSending = false;
    }
  }

  async function changeIsRead(messages: MessageId[]) {
    const snapshots = await getSnapshots(updatedMessageIds);

    snapshots?.forEach((docSnapshot, index) => {
      if (
        docSnapshot.data()?.userId !== userEmail &&
        docSnapshot.data()?.isRead === false &&
        !isAdmin
      ) {
        firebase.functions().httpsCallable('api-messaging-updatemessageisread')({
          messageId: messages[index]
        });
      }
    });
    getMessages();
  }
</script>
